import React from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle2, Lock, ShieldCheck, BadgeCheck } from 'lucide-react';
import { CTAButton } from './Shared';
interface OfferCardProps {
  compact?: boolean;
  ctaText?: string;
}
export const OfferCard: React.FC<OfferCardProps> = ({
  compact = false,
  ctaText = 'GET VOLLEYBALL READY PRO NOW'
}) => {
  return <div className="bg-navy-900 border border-white/10 rounded-2xl p-5 md:p-8 shadow-2xl max-w-2xl mx-auto text-center relative overflow-hidden" data-id="element-102" data-mp="mkgems1arsry">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-vbgold/5 blur-[100px] pointer-events-none" data-id="element-103" data-mp="1f7kmd4rryl7f" />

      {!compact && <>
          <div className="inline-flex items-center gap-2 bg-vbgold text-navy-900 px-4 py-1.5 rounded-full text-xs md:text-sm font-bold uppercase tracking-wider shadow-[0_0_20px_rgba(244,169,31,0.3)] mb-4 md:mb-6" data-id="element-104" data-mp="15hrae2nq042n">
            <Star className="w-4 h-4 fill-navy-900" data-id="element-105" data-mp="1y4vc9yrio2a7" />
            The Complete Offer
          </div>

          <h3 className="font-display text-2xl md:text-4xl uppercase leading-tight mb-5" data-id="element-106" data-mp="8h48arsep3m1">
            Unlock Your{' '}
            <span className="text-vbgold" data-id="element-107" data-mp="de4dl0hfm2c3">Volleyball Ready Pro</span> Today:
          </h3>

          <p className="text-gray-400 text-xs md:text-sm font-bold uppercase tracking-widest mb-4" data-id="element-108" data-mp="3vsdlzkim6r3p">
            Total Content Value
          </p>

          <div className="space-y-3 mb-4 text-left max-w-md mx-auto" data-id="element-109" data-mp="3luz73pccaadi">
            <div className="flex items-center justify-between" data-id="element-110" data-mp="3lwse55qv6wm1">
              <div className="flex items-center gap-3" data-id="element-111" data-mp="3qulkbys63qmb">
                <CheckCircle2 className="w-5 h-5 text-vbgold flex-shrink-0" data-id="element-112" data-mp="3cuasasf4g5zk" />
                <span className="text-gray-200 text-sm md:text-base" data-id="element-113" data-mp="3cwdsu6dwhhij">
                  The Complete Coaching Bible · 200 Pages
                </span>
              </div>
              <span className="text-gray-500 line-through decoration-vbred decoration-2 font-medium" data-id="element-114" data-mp="1b364y8k81rl1">
                $97
              </span>
            </div>
            <div className="flex items-center justify-between" data-id="element-115" data-mp="2o1pvazi8mlf3">
              <div className="flex items-center gap-3" data-id="element-116" data-mp="2nytvf5mtxmo0">
                <CheckCircle2 className="w-5 h-5 text-vbgold flex-shrink-0" data-id="element-117" data-mp="2j127snt7wmpm" />
                <span className="text-gray-200 text-sm md:text-base" data-id="element-118" data-mp="2f003hskg1kgs">
                  5 Exclusive Free Bonuses · 300 Pages
                </span>
              </div>
              <span className="text-gray-500 line-through decoration-vbred decoration-2 font-medium" data-id="element-119" data-mp="2a3rukwwuani2">
                $82
              </span>
            </div>
            <div className="flex items-center justify-between" data-id="element-120" data-mp="32rdv1wartc0p">
              <div className="flex items-center gap-3" data-id="element-121" data-mp="2xyuhv0fzwiwf">
                <CheckCircle2 className="w-5 h-5 text-vbgold flex-shrink-0" data-id="element-122" data-mp="2xx9npbxlf1z3" />
                <span className="text-gray-200 text-sm md:text-base" data-id="element-123" data-mp="2szhtgb9h73rq">
                  Instant PDF Access
                </span>
              </div>
              <span className="text-gray-500 line-through decoration-vbred decoration-2 font-medium" data-id="element-124" data-mp="3loyj515po6k9">
                $18
              </span>
            </div>

            <div className="border-t border-white/10 my-3 pt-3 flex items-center justify-between" data-id="element-125" data-mp="3t1xte15fzdf0">
              <span className="font-display text-lg md:text-xl font-bold uppercase tracking-wide text-white" data-id="element-126" data-mp="1u2570gg5vzu">
                Real Value
              </span>
              <span className="font-display text-xl md:text-2xl text-vbred line-through decoration-vbred decoration-2 font-bold" data-id="element-127" data-mp="auqjlw9r5yd9">
                $197
              </span>
            </div>
          </div>
        </>}

      <div className={`flex flex-col items-center justify-center ${compact ? 'mb-5' : 'mb-5 mt-5'}`} data-id="element-128" data-mp="krd1cc6s89b2">
        <div className="flex items-center gap-3 mb-1" data-id="element-129" data-mp="pk66h165xjno">
          <span className="text-gray-500 font-display text-2xl md:text-3xl line-through decoration-vbred decoration-2" data-id="element-130" data-mp="uiqwk7rpamye">
            $197
          </span>
          <span className="bg-green-500/20 text-green-400 border border-green-500/30 px-2 py-1 rounded text-xs font-bold uppercase tracking-wider animate-pulse shadow-[0_0_10px_rgba(34,197,94,0.2)]" data-id="element-131" data-mp="yhzrhfyh8qvj">
            86% OFF
          </span>
        </div>
        <div className="font-display text-6xl md:text-7xl text-white font-bold tracking-tighter leading-none mb-1" data-id="element-132" data-mp="lvmxju19ae0x">
          $27
        </div>
        <p className="text-gray-400 text-sm" data-id="element-133" data-mp="zockq1sitozm">
          One-time payment · Instant access
        </p>
      </div>

      <div className="mb-3" data-id="element-134" data-mp="uphuies84y5h">
        <CTAButton text={ctaText} price="— $27 →" hideTrustBadges={true} data-id="element-135" data-mp="6x1a3xl0ku30" />
      </div>

      <p className="italic text-gray-400 text-sm mb-5" data-id="element-136" data-mp="2w90v4c56p6q">
        Everything you need for your entire season — ready to take to the court.
      </p>

      <div className="grid grid-cols-3 gap-2 md:gap-4 mb-5" data-id="element-137" data-mp="gxbmxh34zzhn">
        <motion.div whileHover={{
        y: -2
      }} className="bg-navy-800 border border-white/5 hover:border-vbgold/30 transition-colors duration-300 rounded-xl p-3 md:p-4 flex flex-col items-center justify-center gap-2 text-center shadow-lg" data-id="element-138" data-mp="bw4fxk8tj4c1">
          <Lock className="w-5 h-5 md:w-6 md:h-6 text-vbgold" data-id="element-139" data-mp="359pe5hrefu6u" />
          <span className="text-[10px] md:text-xs font-bold text-white uppercase tracking-wide leading-tight" data-id="element-140" data-mp="35bk111m8dwdk">
            Secure
            <br data-id="element-141" data-mp="2w9122slkg3wl" />
            Payment
          </span>
        </motion.div>
        <motion.div whileHover={{
        y: -2
      }} className="bg-navy-800 border border-white/5 hover:border-vbgold/30 transition-colors duration-300 rounded-xl p-3 md:p-4 flex flex-col items-center justify-center gap-2 text-center shadow-lg" data-id="element-142" data-mp="2wau6e18pic1f">
          <ShieldCheck className="w-5 h-5 md:w-6 md:h-6 text-vbgold" data-id="element-143" data-mp="3sy8r4ale8v59" />
          <span className="text-[10px] md:text-xs font-bold text-white uppercase tracking-wide leading-tight" data-id="element-144" data-mp="3f6u3trkge7se">
            7-Day
            <br data-id="element-145" data-mp="3k4lvqll3ltwl" />
            Guarantee
          </span>
        </motion.div>
        <motion.div whileHover={{
        y: -2
      }} className="bg-navy-800 border border-white/5 hover:border-vbgold/30 transition-colors duration-300 rounded-xl p-3 md:p-4 flex flex-col items-center justify-center gap-2 text-center shadow-lg" data-id="element-146" data-mp="bq4y27sp323s">
          <BadgeCheck className="w-5 h-5 md:w-6 md:h-6 text-vbgold" data-id="element-147" data-mp="lfk4mk0cmlhl" />
          <span className="text-[10px] md:text-xs font-bold text-white uppercase tracking-wide leading-tight" data-id="element-148" data-mp="gewiabn2estp">
            Verified
            <br data-id="element-149" data-mp="bfjloz6e67dx" />
            Purchase
          </span>
        </motion.div>
      </div>

      <div data-id="element-150" data-mp="7fsxn38925d3">
        <p className="text-gray-500 text-[10px] md:text-xs font-bold uppercase tracking-widest mb-4" data-id="element-151" data-mp="7fj63b7k3q5a">
          Accepted Payments
        </p>
        <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-152" data-mp="2m6lrd9wu5ic">
          <div className="bg-white rounded px-3 py-1.5 flex items-center justify-center min-w-[50px]" data-id="element-153" data-mp="3tuls9vsgwdc2">
            <span className="text-blue-800 font-bold italic text-sm" data-id="element-154" data-mp="3ox2d8tny3wj2">VISA</span>
          </div>
          <div className="bg-white rounded px-3 py-1.5 flex items-center justify-center min-w-[50px] gap-0.5" data-id="element-155" data-mp="3jvd0n9l2rasv">
            <div className="w-3 h-3 rounded-full bg-red-500 opacity-90" data-id="element-156" data-mp="3fwnotlfoq1bc" />
            <div className="w-3 h-3 rounded-full bg-yellow-500 opacity-90 -ml-1.5 mix-blend-multiply" data-id="element-157" data-mp="1vbz3l013dysl" />
          </div>
          <div className="bg-white rounded px-3 py-1.5 flex items-center justify-center min-w-[50px]" data-id="element-158" data-mp="1zg6u92r41otg">
            <span className="text-blue-600 font-bold text-[10px] tracking-wider" data-id="element-159" data-mp="24b3ylwdg3a00">
              AMEX
            </span>
          </div>
          <div className="bg-white rounded px-3 py-1.5 flex items-center justify-center min-w-[50px] gap-1" data-id="element-160" data-mp="1bp1esop30yjo">
            <span className="text-black text-xs" data-id="element-161" data-mp="1gmuldiuarukh"></span>
            <span className="text-black font-medium text-xs" data-id="element-162" data-mp="1gl9pnpw8y5l1">Pay</span>
          </div>
          <div className="bg-white rounded px-3 py-1.5 flex items-center justify-center min-w-[50px] gap-1" data-id="element-163" data-mp="1lle4lbhias95">
            <span className="text-blue-500 font-bold text-xs" data-id="element-164" data-mp="1qficbwylj4ba">G</span>
            <span className="text-gray-600 font-medium text-xs" data-id="element-165" data-mp="sxidqnembuka">Pay</span>
          </div>
        </div>
      </div>
    </div>;
};